import { MultiSelect, MultiSelectProps } from "@mantine/core";

export function EMultiSelect({ ...props }: MultiSelectProps) {

  const handlechange = (value: string[]) => {
    const isAll = value?.includes("select-all");
    const isRemoveAll = value?.includes("remove-all");

    if (props?.onChange) {
      isAll ?
        props.onChange(
          props?.data ?
            props?.data?.map((each: any) => each?.value as string)
            : []
        )
        :
        isRemoveAll ?
          props?.onChange([])
          :
          props?.onChange(value);
    };
  };


  return (
    <MultiSelect
      className={`${props?.data?.length && props?.data?.length > 15 ? `col-span-2` : ``}`}
      radius={"md"}
      size={"md"}
      maxDropdownHeight={220}
      // mah={400}
      scrollAreaProps={{ scrollHideDelay: 0 }}
      searchable
      {...props}
      data={
        props?.data
          ? props?.data?.length <= 500 ?
          [
            { label: "Select All", value: "select-all" },
            { label: "Remove All", value: "remove-all" },
            ...props.data
          ]:[
            // { label: "Select All", value: "select-all" },
            { label: "Remove All", value: "remove-all" },
            ...props.data
          ]
          :
          []
      }
      comboboxProps={{
        transitionProps: { transition: "fade-down", duration: 200 },
      }}
      // rightSection={
      //   <div className="cursor-pointer"
      //     onClick={() =>
      //       props?.onChange && props?.onChange([])}
      //   >
      //     <MdClose />
      //   </div>
      // }
      onChange={(value) => handlechange(value)}
    />
  );
}